import { AppState } from "@store";
import { existingAdUnitListSelector } from "./existingAdUnitListSelector";
import { campaignCreativesForm } from "@store";

export function adUnitInfoSelector(appState: AppState): AdUnitInfoWithLinks | undefined {
    const adUnits = existingAdUnitListSelector(appState);
    const formData = campaignCreativesForm.selector(appState.campaignState.campaignCreativesForm);

    const adUnit = adUnits.find(f => f.id === formData.fields.adUnitId.value);

    if (!adUnit) {
        return undefined;
    }

    return {
        id: adUnit.id,
        name: adUnit.name,
        demoUrl: adUnit.links.filter(l => l.rel === "demo").map(l => l.href)[0],
        screenUrl: adUnit.links.filter(l => l.rel === "screenshot").map(l => l.href)[0],
        previewUrl: adUnit.links.filter(l => l.rel === "preview").map(l => l.href)[0]
    };
}

export interface AdUnitInfoWithLinks {
    id: string;
    name: string;

    demoUrl: string;
    screenUrl: string;
    previewUrl: string;
}
